import React, { useContext, useEffect, useRef, useState } from "react";
import useAxios from "../../common/hook/useAxios";
import { toast } from "react-toastify";
import { FaCheckCircle, FaEdit, FaExclamationCircle, FaEye, FaEyeSlash, FaSpinner, FaTrash } from "react-icons/fa";
import PatDashInsTable from "../../components/PatDashInsTable";
import PatDashEligTable from "../../components/PatDashEligTable";
import { AuthContext } from "../../context/AuthContext";
import Dropdown from "../../components/Dropdown";
import Button from "../../components/Button";
import debounce from "lodash.debounce";
import useAutoSave from "../../common/hook/useAutoSave";
import { useSearchParams } from "react-router-dom";
import { extractDate, formatDateForInput, formatPhoneNumber, getCurrentDate, parseDateString } from "../../constant";
import AppointmentModal from "../../components/AppointmentModal";
import SidebarComponent from "../../components/Sidebar";
import Appointments from "../../components/FilerAppointment";
import { usePatientDemographic } from "../../context/DempgraphicContext";

const PatientDashobard = () => {
  const { request } = useAxios();
  const { patientDemographics, setPatientDemographics } = usePatientDemographic()
  const [searchParams] = useSearchParams();
  const patientId = searchParams.get('patientId');
  const autoSaveRefs = useRef({});
  const { user } = useContext(AuthContext);
  const [selectedInsurance, setSelectedInsurance] = useState([]); //for primary
  const [insurance, setInsurance] = useState([]) //for all
  const [selectedSecondaryIns, setSelectedSecondaryIns] = useState([]); //for secondary
  const [locations, setLocations] = useState([]);
  const [selected, setSelected] = useState("primary");
  const [selectedLocation, setSelectedLocation] = useState("");
  const [address, setAddress] = useState("");
  const [cell, setCell] = useState("");
  const [zip, setZip] = useState("");
  const [isShowPswd, setIsShowPswd] = useState(false);
  const [payerData, setPayerData] = useState("");
  const [benefitData, setBenefitData] = useState("");
  const [objProviderData, setobjProviderData] = useState("");
  const [receiverData, setReceiverData] = useState("");
  const [objPatData, setobjPatData] = useState("");
  const [subscriberData, setSubscriberData] = useState("");
  const [addisubscriberData, setAddiSubscriberData] = useState("");
  const [coInsurance, setCoInsurance] = useState("");
  const [coPayment, setCoPayment] = useState("");
  const [deductibleDta, setDeductibleDta] = useState("");
  const [eligibilityData, setEligibilityData] = useState("");
  const [appointmentDetails, setAppointmentDetails] = useState([])
  const [PADetails, setPADetails] = useState([])
  const [DOSDate, setDOSDate] = useState(new Date())
  const [error, setError] = useState("")
  const [open, setOpen] = useState(false)
  const [errorMessages, setErrorMessages] = useState({
    cell: "",
    address: "",
    zip: "",
  });
  const [saveStatus, setSaveStatus] = useState({
    cell: null,
    address: null,
    zip: null,
  });
  const [isOpen, setIsOpen] = useState(false)
  useEffect(() => {
    getPatientInsurance();
    getLocation();
    getAppointment();
    getPA();
  }, []);
  useEffect(() => {
    setCell(patientDemographics?.CellMainPhone);
    setAddress(patientDemographics?.Address1)
    setZip(patientDemographics?.Zip)
  }, [patientDemographics])

  const getPatientInsurance = () => {
    request(
      `${process.env.REACT_APP_PATIENT_PORTAL_URL}/PatientInsuranceDetails?PatientId=${patientId}`,
      {
        method: "GET",
      },
    )
      .then((data) => {
        const sortedData = [...data].sort((a, b) => {
          if (a?.InsType === "1") return -1;
          if (b?.InsType === "1") return 1;
          return 0;
        });
        setInsurance(sortedData)
        const filterPrimaryIns = data?.filter((item) => item.InsType == 1);
        const filterSecondaryIns = data?.filter((item) => item.InsType == 2);
        setSelectedInsurance(filterPrimaryIns);
        setSelectedSecondaryIns(filterSecondaryIns);
        if (selected === "primary") {
          handlePatEligibilityDetails(filterPrimaryIns[0]);
        } else if (selected === "secondary") {
          handlePatEligibilityDetails(filterSecondaryIns[0]);
        }
      })
      .catch(() => {
        toast.error("Error occured while fetching insurance", {
          autoClose: 3000,
        });
      });
  };

    const getDM = () => {
      request(
        `${process.env.REACT_APP_PATIENT_PORTAL_URL}/PatientDemography?PatientId=${patientId}`,
        {
          method: "GET",
        },
      )
        .then((data) => {
          const parsedData = JSON.parse(data);
          setPatientDemographics(parsedData)
        })
        .catch(() => {
          toast.error("Error occured while fetching demographic details", {
            autoClose: 3000,
          });
        });
    }
  
  // console.log(appointmentDetails);

  const getAppointment = () => {
    request(
      `${process.env.REACT_APP_PATIENT_PORTAL_URL}/PatientAppointment/PatientAppointments?PatientID=${patientId}`,
      {
        method: "GET",
      },
    )
      .then((data) => {
        setAppointmentDetails(data)
      })
      .catch(() => {
        toast.error("Error occured while fetching insurance", {
          autoClose: 3000,
        });
      });
  }
  const { todaysAppointment, mostRecentPrevious, mostRecentNext, filteredAppointments } = Appointments({
    appointmentDetails: appointmentDetails,
    isCounselor: 0,
  });
  const { todaysAppointment: counselorTodaysAppointment, mostRecentPrevious: counselorPrevAppointment, mostRecentNext: counselorNextAppointment, filteredAppointments: counselorAppointment } = Appointments({
    appointmentDetails: appointmentDetails,
    isCounselor: 1,
  });
  const getPA = () => {
    request(
      `${process.env.REACT_APP_PATIENT_PORTAL_URL}/PatientAPI/PatientPADetails?PatientID=${patientId}`,
      {
        method: "GET",
      },
    )
      .then((data) => {
        // console.log(data);
        setPADetails(data)
      })
      .catch(() => {
        toast.error("Error occured while fetching PA details", {
          autoClose: 3000,
        });
      });
  }

  const checkEligibility = (item) => {
    // console.log(item);

    const requestBody = {
      objPatientDetails: {
        PatientID: patientId,
        PolicyNumber: item?.InsPolicyNumber,
        InsCompanyID: item?.InsCoID,
        PracticeID: user?.PracticeID,
        RowIndex: 0,
        DOS: DOSDate
      },
    };
    const url = `${process.env.REACT_APP_PATIENT_PORTAL_URL}/PatientInsuranceDetails/PatientEligibility?sInputJSON=${encodeURIComponent(JSON.stringify(requestBody))}`;
    request(url, {
      headers: {
        Authorization: `Bearer ${user.AuthToken}`,
        "Content-Type": "application/json",
      },
      method: "GET",
    })
      .then((res) => {
        setDOSDate(res)
      })
      .catch(() => {
        toast.error("Error occurred while checking insurance eligibility", {
          autoClose: 3000,
        });
      });
  };
  const getLocation = () => {
    const url = `${process.env.REACT_APP_DROPDOWN_DATA_URL}/GetLocationDetails?sInputJSON={"PracticeID":${user?.PracticeID}}`;
    request(url, {
      method: "GET",
    })
      .then((res) => {
        setLocations(
          res.map((item) => ({
            value: item.LocationId,
            label: item.LocationName,
          })),
        );
      })
      .catch((err) => {
        toast.error("Error occurred while fetching location", {
          autoClose: 3000,
        });
      });
  };
  useEffect(() => {
    const timer = setTimeout(() => {
      Object.keys(saveStatus).forEach((field) => {
        if (saveStatus[field] === "saved") {
          setSaveStatus((prev) => ({ ...prev, [field]: null }));
        }
      });
    }, 3000); // clear after 3 seconds

    return () => clearTimeout(timer);
  }, [saveStatus]);
  const initializeAutoSave = (field) => {
    if (!autoSaveRefs.current[field]) {
      autoSaveRefs.current[field] = debounce(async (value) => {
        try {
          setSaveStatus((prev) => ({ ...prev, [field]: "saving" }));
          await fakeApiCall(field, value);
          setSaveStatus((prev) => ({ ...prev, [field]: "saved" }));
          setErrorMessages((prev) => ({ ...prev, [field]: "" }));
        } catch (error) {
          setSaveStatus((prev) => ({ ...prev, [field]: "error" }));
          setErrorMessages((prev) => ({
            ...prev,
            [field]: `Failed to save ${field}. Please try again.`,
          }));
        }
      }, 10000);
    }
  };

  const saveNotes = async (notes) => {
    const payload = JSON.stringify(JSON.stringify({
      PatientID: patientId,
      PracticeID: user?.PracticeID,
      IsShared: 1,
      Notes: notes,
      noteText: notes,
      UserID: user?.userId,
    }));

    const url = `${process.env.REACT_APP_PATIENT_PORTAL_URL}/PatientAPI/SavePatientNotes`;

    try {
      await request(url, {
        headers: {
          Authorization: `Bearer ${user.AuthToken}`,
          "Content-Type": "application/json",
        },
        method: "POST",
        data: payload,
      });
      // toast.success("Notes Updated Successfully");
    } catch (error) {
      console.error("Error saving notes:", error);
      toast.error("Error occurred while updating notes", {
        autoClose: 3000,
      });
    }
  };

  const saveAlerts = async (alerts) => {
    const payload = JSON.stringify(JSON.stringify({
      PatientID: patientId,
      PracticeID: user?.PracticeID,
      IsShared: 1,
      Notes: alerts,
      noteText: alerts,
      UserID: user?.userId,
    }));

    const url = `${process.env.REACT_APP_PATIENT_PORTAL_URL}/PatientAPI/SavePatientAlertNotes`;

    try {
      await request(url, {
        headers: {
          Authorization: `Bearer ${user.AuthToken}`,
          "Content-Type": "application/json",
        },
        method: "POST",
        data: payload,
      });
      // toast.success("Alerts Updated Successfully");
    } catch (error) {
      console.error("Error saving notes:", error);
      toast.error("Error occurred while updating notes", {
        autoClose: 3000,
      });
    }
  };

  useEffect(() => {
    getNotes()
    getAlerts()
  }, [patientId])
  // console.log(patientId);

  const getNotes = async () => {
    const url = `${process.env.REACT_APP_PATIENT_PORTAL_URL}/PatientAPI/GetPatientNotes?sInputJSON={"PracticeID":${user?.PracticeID}, "PatientID":${patientId}}`;
    request(url, {
      method: "GET",
    })
      .then((res) => {
        // console.log(res?.data?.SharedNotes1);

        setNotes(res?.Data?.SharedNotes1[0]?.notes)
      })
      .catch((err) => {
        toast.error("Error occurred while fetching location", {
          autoClose: 3000,
        });
      });
  };

  const getAlerts = async () => {
    const date = await getCurrentDate(new Date())
    const url = `${process.env.REACT_APP_PATIENT_PORTAL_URL}/PatientAPI/GetPatientAlertNotes?sInputJSON={"PatientID":${patientId}, "sCurrentWorkingDate":"${date}"}`;
    request(url, {
      method: "GET",
    })
      .then((res) => {
        // console.log(res?.data?.SharedNotes1);

        setAlerts(res?.Data)
      })
      .catch((err) => {
        toast.error("Error occurred while fetching location", {
          autoClose: 3000,
        });
      });
  };

  const [notes, isSaving, setNotes] = useAutoSave('', saveNotes, 30000);
  const [alerts, isSavings, setAlerts] = useAutoSave('', saveAlerts, 30000)

  const fakeApiCall = (field, value) => {
    let completeUrl = "";
    let sInputJSON = {};
    if (field === "cell") {
      completeUrl = "ContactNumber";
      sInputJSON = {
        PatInfo: {
          PatientID: patientId,
          ContactNumber: value.replace(/\D/g, ""),
        },
      };
    } else if (field === "zip") {
      completeUrl = "ZipDetails";
      sInputJSON = {
        PatInfo: {
          PatientID: patientId,
          Zip: value,
        },
      };
    } else if (field === "address") {
      completeUrl = "Address";
      sInputJSON = {
        PatInfo: {
          PatientID: patientId,
          Address: value,
        },
      };
    }

    const url = `${process.env.REACT_APP_PATIENT_PORTAL_URL}/PatientDemography/${completeUrl}`;

    return request(url, {
      headers: {
        Authorization: `Bearer ${user.AuthToken}`,
        "Content-Type": "application/json",
      },
      method: "POST",
      data: JSON.stringify(JSON.stringify(sInputJSON))
    })
      .then(async () => {
        toast.success("User Demographics Updated Successfully");
        await getDM(patientId)
      })
      .catch(() => {
        toast.error("Error occurred while updating demographic details", {
          autoClose: 3000,
        });
      });
  };



  const validateField = (field, value) => {
    let errorMessage = "";
    switch (field) {
      case "cell":
        const rawNumber = value.replace(/\D/g, "").slice(0, 10); // only digits, max 10
        const formattedNumber = formatPhoneNumber(rawNumber);
        setCell(formattedNumber);
        // Validate length
        if (rawNumber.length !== 10) {
          errorMessage = "Cell number must be 10 digits.";
        }
        break;
      case "address":
        if (value.trim()?.length < 5) {
          errorMessage = "Address must be at least 5 characters long.";
        }
        break;
      case "zip":
        if (!/^\d{5,6}$/.test(value)) {
          errorMessage = "Zip code must be 5-6 digits.";
        }
        break;
      default:
        break;
    }
    return errorMessage;
  };

  const SaveStatusIndicator = ({ status }) => {
    if (status === "saving") {
      return (
        <>
          <FaSpinner className="ml-2 animate-spin text-blue-500" title="Saving..." />
        </>
      );
    }

    if (status === "saved") {
      return (
        <FaCheckCircle className="ml-2 text-green-500" title="Saved" />
      );
    }

    if (status === "error") {
      return (
        <FaExclamationCircle className="ml-2 text-red-500" title="Error" />
      );
    }

    return null;
  };

  const toggleMenu = () => {
    setIsOpen(false)
  }

  const handlePatEligibilityDetails = (item) => {
    setPayerData("");
    setReceiverData("");
    setSubscriberData("");
    setBenefitData("");
    setobjPatData("");
    setAddiSubscriberData("");
    setCoInsurance("");
    setCoPayment("");
    setDeductibleDta("");
    setobjProviderData("");
    var jsoninput = {
      PatientID: patientId,
      InsCompanyID: item?.InsCoID,
      PolicyNumber: item?.InsPolicyNumber,
    };
    var inputJSON = JSON.stringify({ objPatientDetails: jsoninput });
    const url = `${process.env.REACT_APP_PATIENT_PORTAL_URL}/PatientInsuranceDetails/EligibilityDetails?sInputJSON=${inputJSON}`;
    fetch(url, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${user.AuthToken}`,
      },
    })
      .then((response) => {
        if (response.status != 200) {
          // console.log("response.status", response.status);
        } else return response.json();
      })
      .then((data) => {
        const parsedData = JSON.parse(data);
        setPayerData(parsedData.objPayer);
        setReceiverData(parsedData.objReceiver);
        setSubscriberData(parsedData.objSubscriber);
        setBenefitData(parsedData.objBenefit);
        setobjPatData(parsedData.objPatient);
        setAddiSubscriberData(parsedData.objSubAddtlInfo);
        setCoInsurance(parsedData.objCoInsurace);
        setCoPayment(parsedData.objCopayment);
        setDeductibleDta(parsedData.objDeductible);
        setobjProviderData(parsedData.ojbProvider);
      })

      .catch((error) => {
        console.error("Error fetching Insurance names:", error);
      });
  };

  const handleChange = (field, value) => {
    switch (field) {
      case "cell":
         const raw = value.replace(/\D/g, "").slice(0, 10);
                const formatted = formatPhoneNumber(raw);
                setCell(formatted);
        break;
      case "address":
        setAddress(value);
        break;
      case "zip":
        const numeric = value.replace(/\D/g, "").slice(0, 6);
                setZip(numeric);
                break;
      default:
        break;
    }
     setSaveStatus((prev) => ({ ...prev, [field]: "saving" }));
        const errorMessage = validateField(field, value);
        setErrorMessages((prev) => ({ ...prev, [field]: "" }));

    // Skip autoSave if there’s a validation error
    if (!errorMessage) {
      initializeAutoSave(field);
      autoSaveRefs.current[field](value);
    } else {
       autoSaveRefs.current[field]?.cancel();
            setSaveStatus((prev) => ({ ...prev, [field]: null }));
            setErrorMessages((prev) => ({ ...prev, [field]: errorMessage }));
    }
  };
  const retrySave = (field) => {
    autoSaveRefs.current[field]?.flush();
  };

  if (!patientId) {
    return <div className="flex flex-col items-center justify-center p-6 bg-red-100 border border-red-300 rounded-lg shadow-md mx-auto my-8 w-full max-w-md">
      <h2 className="text-lg font-semibold text-red-700 mb-2">
        No Patients Available
      </h2>
      <p className="text-sm text-red-600 mb-4">
        Patient ID is missing. Please provide a valid Patient ID.
      </p>
    </div>
  }
  return (
    <>
      {/* <Appointments appointmentDetails={appointmentDetails} isCounselor={0} /> */}
      <SidebarComponent open={open} setOpen={setOpen} setIsAppointment={setIsOpen} />
      <AppointmentModal isOpen={isOpen} data={appointmentDetails} toggleMenu={toggleMenu} />
      <div className="flex flex-row">
        <div className="grid grid-cols-7 border-r-2 border-blue-400">
          <div className="col-span-2">
            <h3 className="bg-red-500 text-white col-span-2 text-lg py-1 pl-2">Alert !</h3>
            <textarea
              rows="4"
              // cols="44"
              className="border border-black m-1 rounded-md w-[99%]"
              value={alerts}
              onChange={(e) => setAlerts(e.target.value)}
              style={{ resize: "none" }}
            />
            {isSavings && <div>Saving...</div>}
            <h3 className="bg-blue-500 text-white col-span-2 text-lg p-1">
              Insurance
            </h3>
            <div className="overflow-x-scroll p-1">
              <table>
                <thead>
                  <tr className="bg-blue-400 border-b text-white">
                    <th style={{ whiteSpace: "nowrap" }} className="p-2 border-r">
                      #
                    </th>
                    <th style={{ whiteSpace: "nowrap" }} className="p-2 border-r">
                      Type
                    </th>
                    <th style={{ whiteSpace: "nowrap" }} className="p-2 border-r">
                      Insurance
                    </th>
                    <th style={{ whiteSpace: "nowrap" }} className="p-2 border-r">
                      Policy
                    </th>
                    <th style={{ whiteSpace: "nowrap" }} className="p-2 border-r">
                      DOS
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {Array.isArray(insurance) && insurance?.length > 0 ? insurance.map((item, index) => {
                    const date = new Date(item?.EligibilityDOS);
                    const validDate = !isNaN(date) ? formatDateForInput(date) : formatDateForInput(DOSDate);
                    return (
                      <tr key={index} className="border-b">
                        <td style={{ whiteSpace: "nowrap" }} className=" border-r p-2">
                          {index + 1}
                        </td>
                        <td style={{ whiteSpace: "nowrap" }} className={` border-r p-2 ${item?.InsType === "1" ? 'bg-yellow-100' : 'bg-blue-200'} `}>
                          {item?.InsType === "1" && "Primary"}
                          {item?.InsType === "2" && "Secondary"}
                        </td>
                        <td style={{ whiteSpace: "nowrap" }} className=" border-r p-2">
                          {item?.InsCoName}
                        </td>
                        <td style={{ whiteSpace: "nowrap" }} className={`border-r p-2 ${item?.PatientInsStatus === "active" ? 'bg-green-300' : 'bg-pinkishRed'}`}>
                          {item?.InsPolicyNumber} <br></br>
                          {/* <button className="bg-orange text-xs p-2 text-white rounded-lg">
                      Mark as Inactive
                    </button> */}
                        </td>
                        <td style={{ whiteSpace: "nowrap" }} className={`border-r p-2 ${item?.PatientInsStatus === "active" ? 'bg-green-300' : 'bg-pinkishRed'}`}>
                          <input
                            type="date"
                            id="from-date"
                            value={validDate}
                            onChange={(e) => {
                              const dateString = e.target.value;
                              const newDate = parseDateString(dateString);
                              if (newDate) {
                                setDOSDate(newDate);
                                setError("");
                              } else {
                                setError("Invalid date format.");
                              }
                            }}
                            className="my-1 block w-[200px] px-3 py-2 border border-gray-600 rounded-md bg-white text-black shadow-sm focus:outline-none focus:ring focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                          />
                          <Button title="Check" onClick={() => checkEligibility(item)} />
                        </td>
                      </tr>
                    );
                  }) : <tr>No insurance found</tr>}
                </tbody>
              </table>
            </div>
            <h3 className="bg-blue-500 text-white col-span-2 text-lg p-1">
              Appointments :
            </h3>
            <h3 className="bg-gray-300 text-blue-700 rounded-sm">
              Next : {mostRecentNext ? `${extractDate(mostRecentNext?.AppointmentDate)} | ${mostRecentNext?.AppointmentTime}` : null}
            </h3>
            <h3 className="bg-yellow-200 text-gray-800 rounded-sm">Current : {todaysAppointment ? `${extractDate(todaysAppointment?.AppointmentDate)} | ${todaysAppointment?.AppointmentTime}` : null}</h3>
            <h3 className="bg-gray-200 text-gray-500 rounded-sm">
              Previous : {mostRecentPrevious ? `${extractDate(mostRecentPrevious?.AppointmentDate)} | ${mostRecentPrevious?.AppointmentTime}` : null}
            </h3>

            <h3 className="bg-orange text-white">Counselor Appointments :</h3>
            <h3 className="bg-gray-300 text-blue-700 rounded-sm">
              Next : {counselorNextAppointment ? `${extractDate(counselorNextAppointment?.AppointmentDate)} | ${counselorNextAppointment?.AppointmentTime}` : null}
            </h3>
            <h3 className="bg-yellow-200 text-gray-800 rounded-sm">Current : {counselorTodaysAppointment ? `${extractDate(counselorTodaysAppointment?.AppointmentDate)} | ${counselorTodaysAppointment?.AppointmentTime}` : null}</h3>
            <h3 className="bg-gray-200 text-gray-500 rounded-sm">
              Previous : {counselorPrevAppointment ? `${extractDate(counselorPrevAppointment?.AppointmentDate)} | ${counselorPrevAppointment?.AppointmentTime}` : null}
            </h3>

            <h3 className="bg-blue-500 text-white p-1 text-lg">DM :</h3>
            <form className="grid grid-cols-3">
              <div className="col-span-3">
                {" "}
                <Dropdown
                  items={locations}
                  label={"Location:"}
                  setSelectedValue={setSelectedLocation}
                  isHeader={false}
                />
              </div>
            <div className="text-md font-medium">Cell : #</div>
                    <div className="col-span-2">
                        <input
                            type="tel"
                            inputMode="numeric"
                            maxLength={14}
                            className="py-1 px-2 border border-gray-400 rounded-md w-3/4 my-1"
                            value={cell}
                            onChange={(e) => handleChange("cell", e.target.value)}
                        />
                        <SaveStatusIndicator status={saveStatus.cell} />
                        {errorMessages.cell && (
                            <div className="text-red-500 text-sm">{errorMessages.cell}</div>
                        )}
                    </div>
                    <div className="text-md font-medium">Address1 :</div>
                    <div className="col-span-2">
                        <input
                            type="text"
                            className="py-1 px-2 border border-gray-400 rounded-md w-3/4 my-1"
                            value={address}
                            onChange={(e) => handleChange("address", e.target.value)}
                        />
                        <SaveStatusIndicator status={saveStatus.address} />
                        {errorMessages.address && (
                            <div className="text-red-500 text-sm">
                                {errorMessages.address}
                            </div>
                        )}
                    </div>
                    <div className="text-md font-medium">Zip Code :</div>
                    <div className="col-span-2">
                        <input
                            type="tel"
                            inputMode="numeric"
                            pattern="\d{5}"
                            maxLength={5}
                            className="py-1 px-2 border border-gray-400 rounded-md w-3/4 my-1"
                            value={zip}
                            onChange={(e) => handleChange("zip", e.target.value)}
                        />

                        <SaveStatusIndicator status={saveStatus.zip} />
                        {errorMessages.zip && (
                            <div className="text-red-500 text-sm">{errorMessages.zip}</div>
                        )}
                    </div>
              <div className="text-md font-medium">City :</div>
              <div>{patientDemographics?.CityName}</div>
              <div className="text-md font-medium">State : {patientDemographics?.StateName}</div>
            </form>

            <h3 className="bg-blue-500 text-white p-1 text-lg">Login :</h3>
            <div className="grid grid-cols-3">
              <div className="text-md font-medium">Username</div>
              <div className="col-span-2">
                <input
                  type="text"
                  className="py-1 px-2 border border-gray-400 rounded-md w-3/4 my-1"
                />
              </div>
              <div className="text-md font-medium">Password</div>
              <div className="col-span-2 flex flex-row items-center justify-start gap-2">
                <input
                  type={isShowPswd ? "text" : "password"}
                  className="py-1 px-2 border border-gray-400 rounded-md w-3/4 my-1 cursor-pointer"
                />
                {isShowPswd ? (
                  <FaEyeSlash
                    onClick={() => {
                      setIsShowPswd(!isShowPswd);
                    }}
                  />
                ) : (
                  <FaEye
                    onClick={() => {
                      setIsShowPswd(!isShowPswd);
                    }}
                  />
                )}
              </div>
              <div className="text-md font-medium">Email</div>
              <div className="col-span-2">
                <input
                  type="email"
                  className="py-1 px-2 border border-gray-400 rounded-md w-3/4 my-1 mr-1"
                  value={patientDemographics?.Email1 || patientDemographics?.Email2}
                />
                {/* <Button title="Save" /> */}
              </div>
            </div>

            <h3 className="bg-blue-500 text-white text-lg p-1">Notes :</h3>
            <textarea
              rows="4"
              // cols="44"
              className="border border-black m-1 rounded-md w-[99%]"
              value={notes}
              onChange={(e) => setNotes(e.target.value)}
            />
            {isSaving && <div>Saving...</div>}

            <h3 className="bg-blue-500 text-white text-lg p-1">PA :</h3>
            <div className="overflow-x-scroll w-full p-1">
              <table>
                <thead>
                  <tr className="bg-blue-400 border-b text-white">
                    <th style={{ whiteSpace: "nowrap" }} className="p-2 border-r">
                      Sent Date
                    </th>
                    <th style={{ whiteSpace: "nowrap" }} className="p-2 border-r">
                      Recieved Date
                    </th>
                    <th style={{ whiteSpace: "nowrap" }} className="p-2 border-r">
                      Type
                    </th>
                    <th style={{ whiteSpace: "nowrap" }} className="p-2 border-r">
                      Expiry Date
                    </th>
                    <th style={{ whiteSpace: "nowrap" }} className="p-2 border-r">
                      Updated By
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {Array.isArray(PADetails) && PADetails?.length > 0 ? PADetails.map((item, index) => {
                    return (
                      <tr key={index} className="border-b">
                        <td style={{ whiteSpace: "nowrap" }} className="p-2 border-r">
                        </td>
                        <td style={{ whiteSpace: "nowrap" }} className="p-2 border-r">
                        </td>
                        <td style={{ whiteSpace: "nowrap" }} className="p-2 border-r">
                          {item?.FileNotes}
                        </td>
                        <td style={{ whiteSpace: "nowrap" }} className="p-2 border-r">
                          {item.ExpiryDate}
                        </td>
                        <td style={{ whiteSpace: "nowrap" }} className="p-2 border-r">
                          {item.UpdatedBy}
                        </td>
                      </tr>
                    )
                  }) : <>No results!</>}
                </tbody>
              </table>
            </div>
            <div className="bg-blue-500 text-white flex flex-row items-center p-1 justify-between text-lg">
              Text :{cell}
              <Button title="Send Now" />
            </div>
            <textarea
              rows="4"
              // cols="44"
              className="border border-black m-1 rounded-md w-[99%]"
            />
            {/* </div> */}
          </div>
          <div className="col-span-5 border-l-2 border-blue-400">
            <div className="flex flex-row gap-4 my-2 ml-2">
              <div
                className={`cursor-pointer px-3 py-1.5 ${selected === "primary" ? "bg-yellow-200" : ""
                  }`}
                onClick={() => setSelected("primary")}
              >
                Primary Insurance
              </div>
              <div
                className={`cursor-pointer px-3 py-1.5 ${selected === "secondary"
                  ? "bg-blue-200 "
                  : "text-gray-700"
                  }`}
                onClick={() => setSelected("secondary")}
              >
                Secondary Insurance
              </div>
            </div>
            <div className="overflow-x-scroll">
              {selected === "primary" && (
                <PatDashInsTable
                  selectedInsurance={selectedInsurance}
                  handlePatEligibilityDetails={handlePatEligibilityDetails}
                  patientId={patientId}
                  checkEligibility={checkEligibility}
                  DOSDate={DOSDate}
                  setDOSDate={setDOSDate}
                />
              )}
              {selected === "secondary" && (
                <PatDashInsTable
                  selectedInsurance={selectedSecondaryIns}
                  handlePatEligibilityDetails={handlePatEligibilityDetails}
                  patientId={patientId}
                  checkEligibility={checkEligibility}
                  DOSDate={DOSDate}
                  setDOSDate={setDOSDate}
                />
              )}
            </div>
            <PatDashEligTable
              setEligibilityData={setEligibilityData}
              payerData={payerData}
              benefitData={benefitData}
              objProviderData={objProviderData}
              receiverData={receiverData}
              objPatData={objPatData}
              subscriberData={subscriberData}
              addisubscriberData={addisubscriberData}
              coInsurance={coInsurance}
              coPayment={coPayment}
              deductibleDta={deductibleDta}
            />
          </div>
        </div>
      </div>
    </>
  );
};
// function SaveStatusIndicator({ status, retry }) {
//   if (status === "saving")
//     return (
//       <span className="text-blue-500 text-sm pl-1 font-semibold">
//         Saving...
//       </span>
//     );
//   if (status === "saved")
//     return (
//       <span className="text-green-500 text-sm pl-1 font-semibold">Saved</span>
//     );
//   if (status === "error")
//     return (
//       <span className="text-red-500 text-sm">
//         Error.{" "}
//         <button onClick={retry} className="underline text-blue-500">
//           Retry
//         </button>
//       </span>
//     );
//   return null;
// }
export default PatientDashobard;
